import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { EN } from 'pricing-pages-lib/constants/Languages';
import { PageSection, SectionHeader, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { getCaseStudies, getSSM0009CaseStudies } from '../../constants/case-studies/CaseStudiesConfig';
import { useMedia } from '../../hooks/useMedia';
import { useAppSelector } from '../../reducers';
import { navItemForProductLineSelector } from '../../selectors/RoutingSelectors';
import { useSSM0009Experiment } from '../../utils/experiments/ssm0009';
import Case from './Case';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CaseStudies = ({
  productLine,
  tab
}) => {
  const navItem = useAppSelector(state => navItemForProductLineSelector(state, productLine));
  const {
    isSSM0009Variant
  } = useSSM0009Experiment();
  const isMaxWidthTablet = useMedia('tablet');
  if (I18n.lang !== EN) return null;
  const caseStudies = isSSM0009Variant ? getSSM0009CaseStudies({
    navItem
  }) : getCaseStudies({
    navItem,
    tab
  });
  return /*#__PURE__*/_jsxs(PageSection, {
    "data-selenium-id": "case-studies-container",
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "case-studies.title"
        })
      })
    }), /*#__PURE__*/_jsx(CardGrid, {
      columns: isMaxWidthTablet ? 1 : 2,
      gutterSize: 24,
      paddingInline: "100",
      expandToFill: true,
      children: caseStudies.map(({
        caseStudyKey,
        href,
        logo,
        price
      }) => {
        return /*#__PURE__*/_jsx(Case, {
          caseStudyKey: caseStudyKey,
          href: href,
          logo: logo,
          price: price
        }, caseStudyKey);
      })
    })]
  });
};
export default CaseStudies;